export default "__VITE_ASSET__IwE5LC21__"